<!--
  * name: how to use
  * description: [Main] how to use 컴포넌트 페이지
-->
<template>
  <div>
    <bread-crumb location="how to use"></bread-crumb>
    <!-- 병헌 : 경로 -->
    <page-title class="mt-14"><strong>How to</strong> Use</page-title>
    <!-- 병헌 : 페이지 제목 -->
    <page-sub-title class="mb-180">
      작은 디테일의 차이가 드라마틱한 변화의 기초가 됩니다.<!--  <br>
      피부 타입에 따른 최적의 사용 방법 확인이 중요합니다. -->
    </page-sub-title>
    <type-01 />
    <!-- <type-02 />
    <type-03 /> -->
  </div>
</template>

<script>
import BreadCrumb from '@/components/breadcrumb/BreadCrumb.vue';
import PageTitle from '@/components/page/PageTitle.vue';
import PageSubTitle from '@/components/page/PageSubTitle.vue';
import Type01 from './partial/Type01.vue';
// import Type02 from './partial/Type02.vue';
// import Type03 from './partial/Type03.vue';

export default {
  name: 'HowToUse',
  components: {
    BreadCrumb,
    PageTitle,
    PageSubTitle,
    Type01,
    // Type02,
    // Type03,
  },
};
</script>

<style lang='scss' scoped>
@import '@/assets/css/howtouse.scss';
</style>
